/** Says, once, that a background load failed, so an empty menu or a missing count isn't mistaken for "none". */
import { clearQuietFailures, useQuietFailures } from '../lib/quietly.ts';
import { useI18n } from '../lib/i18n.tsx';
import { Banner, Button } from '../ui/ui.tsx';

export function QuietFailureNotice() {
  const { t } = useI18n();
  if (!useQuietFailures()) return null;
  return <Banner tone="attention" action={<Button onClick={clearQuietFailures}>{t('quiet.dismiss')}</Button>}>{t('quiet.failed')}</Banner>;
}
